import { render } from "./NotificationItem.vue?vue&type=template&id=1b9dec02&scoped=true"
import script from "./NotificationItem.vue?vue&type=script&lang=js"
export * from "./NotificationItem.vue?vue&type=script&lang=js"

import "./NotificationItem.vue?vue&type=style&index=0&id=1b9dec02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b9dec02"]])

export default __exports__